<template>
    <div class="content" style="background-color: #f5f5f5;">
	<div class="nTop" id="toTop" style="background-color:#FFF;">
	  <div class="wrapper clearfix">
	    <a class="logo">
	      <img src="../../assets/images/logo.jpg" alt="佰吉宏安国际能源有限公司" />
	      <h1>佰吉宏安国际能源有限公司</h1>
	    </a>
	    <a class="nt-link" @click="yanzheng('/main')">
	      <img src="../../assets/images/ico01.png" />
	      <span>个人中心</span>
	    </a>
	  </div>
	</div>
	
	<div class="header">
	  <div class="wrapper clearfix">
	    <div class="nav clearfix">
	      <!-- <router-link  to="/about">关于我们</router-link> -->
	      <a @click="tabIndex(1, '/home')" :class="keyIndex == 1 ? 'active' : ''">首页</a>
	      <a @click="tabIndex(2, '/about')" :class="keyIndex == 2 ? 'active' : ''">关于我们</a>
	      <a @click="tabIndex(3, '/honor')" :class="keyIndex == 3 ? 'active' : ''">资质荣誉</a>
	      <a @click="tabIndex(4, '/product')" :class="keyIndex == 4 ? 'active' : ''">主营产品</a>
	      <a @click="tabIndex(5, '/bidding')" :class="keyIndex == 5 ? 'active' : ''">招标信息</a>
	      <a @click="tabIndex(6, '/partner')" :class="keyIndex == 6 ? 'active' : ''">合作伙伴</a>
	      <a @click="tabIndex(7, '/news')" :class="keyIndex == 7 ? 'active' : ''">新闻资讯</a>
	      <a @click="tabIndex(8, '/contact')" :class="keyIndex == 8 ? 'active' : ''">联系我们</a>
	    </div>
	    <div class="dl-an clearfix" v-if="isLogin">
	      <a @click="toPage('/login')">
	        <img src="../../assets/images/ico02.png" />
	        <span>登录</span>
	      </a>
	      <a @click="toPage('/register')">
	        <img src="../../assets/images/ico03.png" />
	        <span>注册</span>
	      </a>
	    </div>
	  </div>
	</div>
	
	
		<div class="top_box">
			<div class="top">
				<div class="top_left">
					个人中心
				</div>
				<div class="top_right">
					您当前所在位置：<a><router-link  to="/home">首页</router-link></a> > <span>个人中心</span>
				</div>
			</div>
		</div>
		<div class="center_box">
			<div class="center_left">
				<div class="left_first">
					个人中心
				</div>
				<div class="left_item" :style="active" @click="openPage('main')">
					<img src="../../assets/icon/m_icon1.png">
					基本信息
				</div>
				<a>
				<div class="left_item" @click="openPage('main_money')">
					<img src="../../assets/icon/m_icon2.png">
					保证金余额
				</div>
				</a>
				<a>
				<div class="left_item" @click="openPage('main_record')">
					<img style="height: 20px ;" src="../../assets/icon/m_icon3.png">
					竞拍记录
				</div>
				</a>
				<a>
				<div class="left_item" @click="openPage('main_news')">
					<img  style="height: 20px ;" src="../../assets/icon/m_icon4.png">
					消息提醒
					<div class="red" v-if="isRed"></div>
				</div>
				</a>
				<a>
				<div class="left_item" @click="quit">
					<img src="../../assets/icon/m_icon5.png">
					退出登录
				</div>
				</a>
			</div>
			<div class="center_right">
				<div class="center_right_top">
					<div class="line"></div>
					基本信息
				</div>
				<div class="center_right_bottom">
					<div class="center_right_tab">
						<div class="tab_item" :class="index == 1 ?'active' : ''" @click="tabIndex1(1)">
							注册信息		
						</div>
						<div class="tab_item"  :class="index == 2 ?'active' : ''" @click="tabIndex1(2)">
							修改密码		
						</div>
						<div class="tab_item"  :class="index == 3 ?'active' : ''" @click="tabIndex1(3)">
							修改手机号		
						</div>
					</div>
					<div class="center_right_content" v-if="index == 1">
						<div class="type_image" v-if="info.app_status == 0">
							<img src="../../assets/image/image1.png"></img>
						</div>
						<div class="type_image1" v-if="info.app_status == 2">
							<img src="../../assets/image/image2.png"></img>
							<div class="type_box">
								<div class="type_title">
									<img src="../../assets/icon/m_icon6.png"></img>
									审核失败原因
								</div>
								<div class="type_content">
									{{info.reason}}
								</div>
							</div>
							<div class="btn_box">
								<div class="btn2">
									修改资料
								</div>
								<div class="btn1">
									联系客服
								</div>
							</div>
						</div>
						<div v-if="type == 1">
						<div class="center_right_input_box">
							<div class="input_box" style="border: none !important;">
								<div class="input_title">
									用户名
								</div>
								<div class="input">
									<el-input v-model="user.name" :disabled="disabled" style="font-size: 12px;" size="small"  placeholder="请输入用户名"></el-input>
								</div>
							</div>
							<div class="input_box" style="border: none !important;">
								<div class="input_title">
								</div>
								<span></span>
								<!-- 用户名限制在4-16位 -->
							</div>
						</div>
					
						<div class="center_right_input_box"  style="margin-top:12px">
							<div class="input_box" style="border: none !important;">
								<div class="input_title">
									电子邮箱
								</div>
								<div class="input">
									<el-input v-model="user.email" :disabled="disabled" style="font-size: 12px;" size="small"  placeholder="请输入邮箱"></el-input>
								</div>
							</div>
							<div class="input_box" style="border: none !important;">
								<div class="input_title">
								</div>
								<span></span>
							</div>
						</div>
						<div class="center_right_input_box"  style="margin-top:12px">
							<div class="input_box" style="border: none !important;">
								<div class="input_title">
									联系人
								</div>
								<div class="input">
									<el-input v-model="user.contactName" :disabled="disabled" style="font-size: 12px;" size="small"  placeholder="请输入联系人姓名"></el-input>
								</div>
							</div>
							<div class="input_box" style="border: none !important;">
								<div class="input_title">
								</div>
								<span></span>
							</div>
						</div>
					
						<div v-if="!disabled" style="display: flex; align-items: center;">
							<div class="btn"   @click="updateInfo()">
								确认提交
							</div>
							<div class="btn" style="margin-left: 10px;"  @click="zhuanhuan()">
								个人转企业
							</div>
						</div>
					
						</div>
						<div v-if="type == 2">
							<div class="center_right_content" >
								<div class="center_right_input_box">
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
											企业名称
										</div>
										<div class="input">
											<el-input v-model="business.business" :disabled="disabled" style="font-size: 12px;" size="small"  placeholder="请输入企业名称"></el-input>
										</div>
									</div>
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
										</div>
										<span></span>
									</div>
								</div>
								<div class="center_right_input_box" style="margin-top:12px">
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
											用户名
										</div>
										<div class="input">
											<el-input v-model="business.name" :disabled="disabled" style="font-size: 12px;" size="small"  placeholder="请输入用户名"></el-input>
										</div>
									</div>
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
										</div>
										<span></span>
										<!-- 用户名限制在4-16位 -->
									</div>
								</div>
								<div class="center_right_input_box"  style="margin-top:12px">
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
											企业地址
										</div>
										<div class="input">
											<el-input v-model="business.address" :disabled="disabled" style="font-size: 12px;" size="small"  placeholder="请输入企业地址"></el-input>
										</div>
									</div>
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
										</div>
										<span></span>
									</div>
								</div>
								<div class="center_right_input_box"  style="margin-top:12px">
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
											企业邮箱
										</div>
										<div class="input">
											<el-input v-model="business.email" :disabled="disabled" style="font-size: 12px;" size="small"  placeholder="请输入邮箱"></el-input>
										</div>
									</div>
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
										</div>
										<span></span>
									</div>
								</div>
								<div class="center_right_input_box"  style="margin-top:12px">
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
											法人代表
										</div>
										<div class="input">
											<el-input v-model="business.legal" :disabled="disabled" style="font-size: 12px;" size="small"  placeholder="请输入法人姓名"></el-input>
										</div>
									</div>
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
										</div>
										<span></span>
									</div>
								</div>
								<div class="center_right_input_box"  style="margin-top:12px" v-if="showUpload">
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
											资质上传
										</div>
										<span v-if="business.qualifications.title" style="text-decoration: underline;color: #af2f24 !important;" @click="openPdf(business.qualifications.attach_uri)">{{business.qualifications.title}}</span>
									</div>
									<div class="input_box" style="margin: 10px 0px; none !important;" v-if="!disabled">
										<div class="input_title">
										</div>
										 <el-button type="primary" @click="tapUpload()">&emsp;&emsp;重新上传&emsp;&emsp;</el-button>
									</div>
								</div>
								<div class="upload-box" v-else>
								    <span class="input_title">资质上传</span>
								    <div class="">
										<el-upload
										  class="upload-demo"
										  action="https://baijihongan.com/api/v1/filemanager"
										  name="imgFile"
										  accept=".pdf"
										  :limit='limit'
										  :data="fileData"
										  :on-preview="handlePreview"
										  :on-remove="handleRemove"
										  :before-remove="beforeRemove"
										  :on-exceed="handleExceed"
										  :on-success="beforSuccess"
										  :file-list="fileList">
											<div style="display: flex;align-items: center;">
												 <el-button type="primary">&emsp;&emsp;上传&emsp;&emsp;</el-button>
												  <el-button type="warning" style="margin-left: 10px;" @click="noUpload()" v-if="!isZh">&emsp;&emsp;取消&emsp;&emsp;</el-button>
											</div>
										  <div class="tip">营业执照副本、开户许可、开票信息的扫描件并加盖<br>公章，PDF格式上传</div>
										</el-upload>
								    </div>
								</div>
								<div class="center_right_input_box"  style="margin-top:12px">
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
											联系人
										</div>
										<div class="input">
											<el-input v-model="business.contactName" :disabled="disabled" style="font-size: 12px;" size="small"  placeholder="请输入联系人姓名"></el-input>
										</div>
									</div>
									<div class="input_box" style="border: none !important;">
										<div class="input_title">
										</div>
										<span></span>
									</div>
								</div>
							
								<div style="display: flex;align-items: center;">
									<div class="btn" v-if="!disabled"  @click="updateInfo()">
										确认提交
									</div>
									<div class="btn" v-if="isZh" style="margin-left: 10px;"  @click="quxiaoZh()">
										取消转换
									</div>
								</div>
								
							</div>
						</div>
					</div>	
						<div class="center_right_content"  v-if="index == 2">
							<div class="center_right_input_box" >
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
										原密码<span>*</span>
									</div>
									<div class="input">
										<el-input v-model="oldpsd" style="font-size: 12px;"  size="small"  placeholder="请输入密码" show-password></el-input>
									</div>
								</div>
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
									</div>
								</div>
							</div>
							<div class="center_right_input_box" style="margin-top:12px">
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
										新密码<span>*</span>
									</div>
									<div class="input">
										<el-input v-model="newpsd" style="font-size: 12px;" size="small"  placeholder="请输入新密码" show-password></el-input>
									</div>
								</div>
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
									</div>
								</div>
							</div>
							<div class="center_right_input_box" style="margin-top:12px">
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
										确认新密码<span>*</span>
									</div>
									<div class="input">
										<el-input v-model="newpsds" style="font-size: 12px;" size="small"  placeholder="请再次输入新密码" show-password></el-input>
									</div>
								</div>
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
									</div>
								</div>
							</div>
							<div class="btn" @click="updatePsd()">
								确认修改
							</div>
						</div>
						<div class="center_right_content"  v-if="index == 3">
							<div class="center_right_input_box" >
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
										联系电话
									</div>
									<div class="input" style="margin-right: 10px;">
										<el-input v-model="mobile" style="font-size: 12px;" size="small"  placeholder="请输入联系电话"></el-input>
									</div>
									<el-button @click="sendYanzheng" type="primary">{{send}}</el-button>
								</div>
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
									</div>
									<span></span>
								</div>
							</div>
							<div class="center_right_input_box" style="margin-top:12px">
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
										验证码
									</div>
									<div class="input">
										<el-input v-model="yzm" style="font-size: 12px;" size="small"  placeholder="请输入验证码"></el-input>
									</div>
								</div>
								<div class="input_box" style="border: none !important;">
									<div class="input_title">
									</div>
									<span></span>
								</div>
							</div>
						
							<div class="btn"  @click="updateMobile()">
								确认修改
							</div>
						</div>
						
				
				</div>
			</div>
		</div>
		<div class="footer">
		  <div class="wrapper">
		    <div class="f-nav">
		      <a @click="tabIndex(1, '/home')">首页</a>
		      <a @click="tabIndex(2, '/about')">关于我们</a>
		      <a @click="tabIndex(3, '/honor')">资质荣誉</a>
		      <a @click="tabIndex(4, '/product')">主营产品</a>
		      <a @click="tabIndex(5, '/bidding')">招标信息</a>
		      <a @click="tabIndex(6, '/partner')">合作伙伴</a>
		      <a @click="tabIndex(7, '/news')">新闻资讯</a>
		      <a @click="tabIndex(8, '/contact')">联系我们</a>
		    </div>
		
		    <div class="f-box flexbox">
		      <img src="../../assets/images/logo_foot.png" alt="佰吉宏安国际能源有限公司" class="logo_foot" />
		      <div class="f-center flexbox33 flexwarp" style="text-align: left;">
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico05.png" />
		          <p>联系电话：{{ footerMassage.mobile }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico06.png" />
		          <p>邮政编码：{{ footerMassage.postal }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico07.png" />
		          <p>访问量：{{ footerMassage.pageviews }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico08.png" />
		          <p>电子邮箱：{{ footerMassage.email }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico09.png" />
		          <p>公司地址：{{ footerMassage.address }}</p>
		        </div>
		        <div class="f-item clearfix">
		          <img src="../../assets/images/ico10.png" />
		          <p>交易量：{{ footerMassage.trading_volume }}</p>
		        </div>
		      </div>
		      <div class="qrcode">
		        <img :src="footerMassage.image_id5_url" alt="" />
		        <p>扫一扫了解更多</p>
		      </div>
		    </div>
		    <div class="copyright">
		      Copyright 2021 ·版权所有 佰吉宏安国际能源有限公司
		      <a href="https://beian.miit.gov.cn" target="_blank">{{ footerMassage.site_icp }}&nbsp;{{ footerMassage.site_wabah }}</a>
		      <br />
		      建议使用1920*1080以上的屏幕分辨率和8.0以上版本的浏览器来访问本站，本站不支持IE浏览器
		    </div>
		  </div>
		</div>
    </div>
</template>

<script>
	import Utils from '../../utils/utils.js';
export default {
    name: 'main',
    data() {
        return {
			limit:1,
			type:2,
           index:1,
		   psd:'',
		   psds:'',
		   oldpsd:'',
		   newpsd:'',
		   newpsds:'',
		   active:'background-color: #e6e6e6;',
		   info:'',
		   fileList:[],
		   fileData:{
		   	type:'file',
		   	path:1,
		   	module:1
		   },
		   showUpload:true,
		   business:{
			   business:'',
			   name:'',
			   email:'',
			   legal:'',
			   address:'',
			   qualificationsId:'',
			   qualifications:'',
			   contactName:'',
			   mobile:''
		   },
		   user:{
			   name:'',
			   email:'',
			   contactName:'',
			   mobile:''
		   },
		   disabled:false,
		   mobile:'',
		   send:'发送验证码',
		   time: 60,
		   yzm:'',
		   isZh:false,//个人转企业判断
			isRed:false,
			
			
			keyIndex:0,
			isLogin: true,
			footerMassage:'',
		};
    },
    mounted() {
		this.getInfo()
		this.getRed()
		
		this.site_info()
	},
    methods: {
		async getRed() {
			var _this = this
		    let { status, message, data } = await this.$ajax('no_read_information', {
					userToken: this.$getStorage('userToken'),
		    });
		    if (status == this.SUCCESS_CODE) {
				  Utils.$emit('getRed','msg');
					if(data == 0){
						_this.isRed = false
					}else{
						_this.isRed = true
					}
		    } else {
		        this.$message(message);
		    }
		},
		quit() {
			this.$confirm('您确定退出吗?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
			  this.$message({
				type: 'success',
				message: '退出成功!'
			  });
			  window.sessionStorage.clear()
			  this.$router.push({
			      path: "/home"
			  });
			  window.location.reload();
			}).catch(() => {
			          
			});
		  },
		  zhuanhuan(){
			 this.business ={
				   business:'',
				   name:'',
				   email:'',
				   legal:'',
				   address:'',
				   qualificationsId:'',
				   qualifications:'',
				   contactName:'',
				   mobile:''
			  }
			  this.fileList = []
			  this.showUpload = false
			  this.isZh = true
			  this.type = 2
		  },
		  quxiaoZh(){
			this.type = 1  
			 this.showUpload = true
			this.isZh = false
		  },
		  updateInfo(){
			var _this = this
			if(_this.type == 2){
				if(_this.business.business == ''){
					_this.$message({
					  message: '请输入企业名称',
					  type: 'warning'
					});
					return false
				}
				if(_this.business.name == ''){
					_this.$message({
					  message: '请输入用户名',
					  type: 'warning'
					});
					return false
				}
				if(_this.business.name.length < 2){
					_this.$message({
					  message: '用户名最少2位',
					  type: 'warning'
					});
					return false
				}
				if(_this.business.address == ''){
					_this.$message({
					  message: '请输入企业地址',
					  type: 'warning'
					});
					return false
				}
				if(_this.business.email == ''){
					_this.$message({
					  message: '请输入企业邮箱',
					  type: 'warning'
					});
					return false
				}
				var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
				if(!reg.test(_this.business.email)){
					_this.$message({
					  message: '您的邮箱格式不正确',
					  type: 'warning'
					});
					return false
				}
				if(_this.business.legal == ''){
					_this.$message({
					  message: '请输入法人姓名',
					  type: 'warning'
					});
					return false
				}
				if(_this.business.qualificationsId == ''){
					_this.$message({
					  message: '请上传资质',
					  type: 'warning'
					});
					return false
				}
				if(_this.business.contactName == ''){
					_this.$message({
					  message: '请输入联系人姓名',
					  type: 'warning'
					});
					return false
				}
			}
			if(_this.type == 1){
				if(_this.user.name == ''){
					_this.$message({
					  message: '请输入用户名',
					  type: 'warning'
					});
					return false
				}
				if(_this.user.name.length < 2){
					_this.$message({
					  message: '用户名最少2位',
					  type: 'warning'
					});
					return false
				}
				if(_this.user.email == ''){
					_this.$message({
					  message: '请输入邮箱',
					  type: 'warning'
					});
					return false
				}
				var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
				if(!reg.test(_this.user.email)){
					_this.$message({
					  message: '您的邮箱格式不正确',
					  type: 'warning'
					});
					return false
				}
				if(_this.user.contactName == ''){
					_this.$message({
					  message: '请输入联系人姓名',
					  type: 'warning'
					});
					return false
				}
			}
			this.sendUpdateInfo()
		  },
		 
		  async sendUpdateInfo(){
		  	var _this = this;
			if(_this.type == 2){
				let { status, message, data } = await _this.$ajax('editInfo', {
					userToken: _this.$getStorage('userToken'),
					business:_this.business.business,
					username:_this.business.name,	
					password:_this.business.psd,	
					address:_this.business.address,		
					email:'',			
					legal:_this.business.legal,	
					qualifications:_this.business.qualificationsId,	
					contact_name:_this.business.contactName,	
					mobile:_this.business.mobile || _this.user.mobile,	
					type:_this.type,	
					business_email:	_this.business.email
				});
				if (status == _this.SUCCESS_CODE) {
					if(_this.isZh){
						_this.business ={
						   business:'',
						   name:'',
						   email:'',
						   legal:'',
						   address:'',
						   qualificationsId:'',
						   qualifications:'',
						   contactName:'',
						   mobile:''
						 }
						 _this.fileList = []
						 _this.showUpload = true
						 _this.isZh = false
					}
				  _this.$message({
					message: '修改成功！请耐心等待审核',
					type: 'success'
				  });
				  _this.getInfo()
				} else {
					_this.$message.error(message);
				}
			}
			if(_this.type == 1){
				let { status, message, data } = await _this.$ajax('editInfo', {
					userToken: _this.$getStorage('userToken'),
					business:'',
					username:_this.user.name,	
					password:'',	
					address:'',		
					email:'',			
					legal:'',	
					qualifications:'',	
					contact_name:_this.user.contactName,	
					mobile:_this.user.mobile,	
					type:_this.type,	
					business_email:	_this.user.email
				});
				if (status == _this.SUCCESS_CODE) {
				  _this.$message({
					message: '修改成功！请耐心等待审核',
					type: 'success'
				  });
				  _this.getInfo()
				} else {
					_this.$message.error(message);
				}
			}
			  
		  },
		updateMobile(){
			var _this = this
			if (!/^1[2-9]\d{9}$/.test(_this.mobile)) {
				_this.$message({
				  message: '请输入有效的手机号',
				  type: 'warning'
				});
			    return false;
			}
			if(_this.yzm == ''){
				_this.$message({
				  message: '请输入验证码',
				  type: 'warning'
				});
				return false
			}
			this.sendUpdateMobile()
		},
		async sendUpdateMobile(){
			var _this = this;
			let { status, message, data } = await _this.$ajax('change_mobile', {
				userToken: _this.$getStorage('userToken'),
				mobile:_this.mobile,
				verify:_this.yzm,
			});
			if (status == _this.SUCCESS_CODE) {
			   _this.$message({
					message: '修改成功！',
					type: 'success'
			   });
				_this.index = 1
				_this.mobile = ''
				_this.yzm = ''
				_this.getInfo()
			} else {
			     _this.$message.error(message);
			}
		},
		updatePsd(){
			var _this = this
			if(_this.oldpsd == ''){
				_this.$message({
				  message: '请输入原密码',
				  type: 'warning'
				});
				return false
			}
			if(_this.newpsd == ''){
				_this.$message({
				  message: '请输入新密码',
				  type: 'warning'
				});
				return false
			}
			if(_this.newpsd.length < 6){
				_this.$message({
				  message: '密码最小4位',
				  type: 'warning'
				});
				return false
			}
			if(_this.newpsds == ''){
				_this.$message({
				  message: '请输入新密码',
				  type: 'warning'
				});
				return false
			}
			if(_this.newpsd != _this.newpsds){
				_this.$message({
				  message: '您两次输入的密码不相同',
				  type: 'warning'
				});
				return false
			}
			this.sendUpdatePsd()
			
		},
		async sendUpdatePsd(){
			var _this = this;
			let { status, message, data } = await _this.$ajax('change_password', {
				 userToken: _this.$getStorage('userToken'),
				old_password:_this.oldpsd,	
				new_password:_this.newpsd
			});
			if (status == _this.SUCCESS_CODE) {
				   _this.$message({
						message: '修改成功！',
						type: 'success'
				   });
				_this.index = 1
				_this.oldpsd = ''
				_this.newpsd = ''
				_this.newpsds = ''
				_this.getInfo()
			} else {
			     _this.$message.error(message);
			}
		},
		// 发送验证码
		sendYanzheng(){
		    var _this = this;
		    if (!/^1[2-9]\d{9}$/.test(_this.mobile)) {
				_this.$message({
				  message: '请输入有效的手机号',
				  type: 'warning'
				});
		        return false;
		    }
		    if (_this.send != '发送验证码') return;
			_this.getVerify()
		},
		async getVerify() {
			var _this = this;
		   let { status, message, data } = await _this.$ajax('verify', {
		   	mobile:_this.mobile,
			type:4
		   });
		   if (status == _this.SUCCESS_CODE) {
			   _this.$message({
					message: '发送成功！请注意查收',
					type: 'success'
			   });
				_this.countDown()
		   } else {
		        _this.$message.error(message);
		   }
		},
		// 验证码倒计时
		countDown() { //验证码倒计时
		    var _this = this;
		    switch (_this.send) {
		        case '发送验证码':
		            _this.send = _this.time + 's';
		            var timer = setInterval(function () {
		                if (--_this.time <= 0) {
		                    clearInterval(timer);
		                    _this.send = '发送验证码';
		                    _this.time = 60;
		                } else {
		                    _this.send = _this.time + 's';
		                }
		            }, 1000);
		            break;
		    }
		},
	
		tapUpload(){
			var _this = this
			_this.fileList = []
			_this.showUpload = false
		},
		noUpload(){
			var _this = this
			_this.fileList = []
			_this.business.qualifications = _this.info.qualifications_info
			_this.business.qualificationsId = _this.info.qualifications
			_this.showUpload = true
		},
		openPage(str){
			this.$router.push({
				path: str,
				// query: {  }
			});
		},
		tabIndex(index,str){
			// this.keyIndex = index
			// window.sessionStorage.setItem('keyIndex', index);
			// this.$setStorage('lastKeyIndex',index)
			// this.$setStorage('keyIndex',index)
			
			this.$router.push({
				path: str
			});
		},
		tabIndex1(index){
			if(index == this.index) return
			this.index = index
		},
        async getInfo() {
			var _this = this
            let { status, message, data } = await _this.$ajax('getInfo', {
                userToken: _this.$getStorage('userToken'),
            });
            if (status === _this.SUCCESS_CODE) {
				_this.info = data
				_this.type = data.type
				if(_this.info.app_status == 1){
					_this.disabled = true
				}else{
					_this.disabled = false
				}
				console.log(_this.fileList)
				_this.business = {
					business:data.business,
					name:data.username,
					email:data.business_email,
					legal:data.legal,
					address:data.address,
					qualifications:data.qualifications_info,
					qualificationsId:data.qualifications,
					contactName:data.contact_name,
					mobile:data.mobile
				}
				_this.user = {
				  name:data.username,
				  email:data.email,
				  contactName:data.contact_name,
				  mobile:data.mobile
				}
            } else {
                _this.$message.error(message);
            }
        },
		handleRemove(file, fileList) {
			this.business.qualificationsId = ''
			console.log(file, fileList);
		 },
		 handlePreview(file) {
			window.open(file.url);
		 },
		 handleExceed(files, fileList) {
		  console.log(files)
		  console.log(fileList)
		// this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
		 },
		
		 beforSuccess(e){
		  console.log(e)
		  this.fileList = []
		  this.business.qualifications = ''
		  var a = {
			  name:e.data.title,
			  url:e.data.attach_uri
		  }
		  this.business.qualificationsId = e.data.id
		  this.fileList.push(a)
			// this.showUpload = true
		 },
		 beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${ file.name }？`);
		 },
		 openPdf(str){
			 // console.log(str)
			 window.open(str);
		 },
		 //底部导航信息
		 async site_info(idnex) {
		   this.timeIndex = idnex;
		   if (this.$getStorage('userToken')) {
		     this.isLogin = false;
		   } else {
		     this.isLogin = true;
		   }
		   let { status, message, data } = await this.$ajax('site_info', {});
		   if (status == this.SUCCESS_CODE) {
		     this.footerMassage = data;
		   } else {
		     this.$message(message);
		   }
		 },
		 yanzheng(str) {
		   var _this = this;
		   if (this.$getStorage('userToken')) {
		     _this.toPage(str);
		   } else {
		     _this.$message({
		       message: '请先登录',
		       type: 'warning'
		     });
		     _this.toPage('/login');
		   }
		 },
		 toPage(pathName, title) {
		   this.$router.push({
		     path: pathName,
		     query: { pageTitle: title }
		   });
		 },
	
    }
};
</script>

<style scoped>
	/* a:hover{ 
		background-color: #F5F5F5 !important;
	} */
	.content{
		background-color: #F5F5F5 !important;
	}
	.top_box{
		width: 100%;
		height:55px;
		background-color: #fff;
		display: flex;
		align-items: center;
	}
	.top{
		width:1320px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 0 auto;
	}
	.top_left{
		font-size: 19px;
		font-weight: bold;
		margin-left: 10px;
	}
	.left_first{
		padding: 12px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		background-color: #8a0d02;
	}
	.red{
		position: absolute;
		background-color: #ff1400;
		width: 7px;
		height: 7px;
		border-radius: 50%;
		right: 38px;
		top: 12px;
		z-index: 80;
	}
	.left_item{
		background-color: #fff;
		padding: 14px 25px;
		display: flex;
		align-items: center;
		font-size: 13px;
		font-weight: bold;
		border-bottom: 1px solid #f3f3f3;
		position: relative;
	}
	.left_item:hover{
		background-color: #F5F5F5 !important; 
	}
	.left_item img{
		width: 18px;
		height: 18px;
		display: block;
		margin-right: 10px;
	}
	.top_right{
		font-size: 10px;
		display: flex;
		align-items: center;
		color:#666666;
		margin-right: 10px;
	}
	.top_right a{
		margin-right:5px;
	}
	.top_right span{
		margin-left: 5px;
		font-weight: 600;
		color: #000 !important;
	}
	.center_box{
		width: 1300px;
		display: flex;
		justify-content: space-between;
		margin: 20px auto;
	}
	
	.center_left{
		background-color: #fff;
		width:150px;
		margin-right: 10px;
		padding-bottom: 200px;
	}
	.center_right{
		flex: 1;
	}
	.center_right_top{
		display: flex;
		align-items: center;
		padding: 12px;
		background-color: #fff;
		margin-bottom: 10px;
		font-size: 12px;
		font-weight: bold;
	}
	.center_right_top div{
		width: 3px;
		height: 14px;
		background-color: #8a0d02;
		margin-right: 8px;
	}
	.center_right_bottom{
		min-height: 500px;
		padding: 20px;
		background-color: #fff;
	}
	.center_right_tab{
		width: 100%;
		border-bottom: 1px solid #f3f3f3;
		height: 35px;
		display: flex;
		margin-bottom: 30px;
	}
	.tab_item{
		line-height: 35px;
		height: 100%;
		width: 130px;
		text-align: center;
		font-size: 10px;
	}
	.active{
		font-size: 13px;
		background-color: #b69862 !important;
		color: #fff !important;
		font-weight: bold !important;
	}
	.center_right_content{
		
		padding:20px 0px 30px 0px;
		display: flex;
		flex-direction: column;
	}
	.center_right_input_box{
		display: flex;
		flex-direction: column;
		margin-top:3px
	}
	.input_title{
		width: 75px;
		font-size: 13px;
		text-align: right;
		margin-right: 10px;
	}
	.input_title span{
		font-size: 12px;
		color: #ff1400;
		margin-left: 2px
	}
	.input{
		border-radius: 3px;
		border:1px solid #dfdfdf;
		box-shadow: 0px 3px 7px 0px rgba(188, 188, 188, 0.23);
		font-size: 12px;
		/* height: 35px; */
		/* padding:0px 10px; */
		width: 250px;
		margin-bottom: 3px;
	}
	/* .input_box span{
		text-decoration: underline;
		color: #af2f24 !important;
	} */
	.input_box{
		display: flex;
		align-items: center;
		font-size: 13px;
	}
	.input_box span{
		font-size: 10px;
		color: #ff1400;
		margin-left: 2px
	}
	.btn{
		width:190px;
		/* margin-left:110px; */
		margin-left:20px;
		border-radius:3px;
		height:45px;
		line-height:45px;
		text-align:center;
		color:#fff;
		font-size:14px;
		background-color:#af2f24;
		margin-top: 20px;
	}
	.btn1{
		width:130px;
		border-radius:3px;
		height:35px;
		line-height:35px;
		text-align:center;
		color:#af2f24;
		font-size:14px;
		background-color:#fff;
		border: 1px solid #af2f24;
	}
	.btn2{
		width:130px;
		border-radius:3px;
		height:35px;
		line-height:35px;
		text-align:center;
		color:#fff;
		font-size:14px;
		background-color:#af2f24;
	}
	.type_image{
		margin-bottom: 20px;
		margin-left: 85px;
		display: flex;
		flex-direction: column;
	}
	.type_image1{
		margin-top: 20px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
	}
	.type_image img{
		width: 230px;
		height: 195px;
	}
	.type_image1 img{
		width: 230px;
		height: 195px;
	}
	.type_box{
		width: 350px;
		display: flex;
		flex-direction: column;
	}
	.type_title{
		display: flex;
		align-items: center;
		font-size: 16px;
		font-weight: bold;
		margin-bottom:5px;
	}
	.type_title img{
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}
	.type_content{
		font-size: 12px;
		color: #808080;
		text-align: left;
		word-break: break-all;
		white-space: nowrap;
	}
	.btn_box{
		display: flex;
		justify-content: space-between;
		width:280px;
		margin-top: 20px;
	}
	.upload-box {
	    display: flex;
		margin-top: 10px;
	    /* height: 93px; */
	}
	.upload-box div {
	    text-align: left;
	}
	.input-box >span, .upload-box >span {
	    display: inline-block;
	    line-height: 42px;
	    width: 75px;
	    text-align: right;
	}
	.input-box .input {
	    border: 1px solid #dfdfdf;
	    border-radius: 5px;
	    width: 340px;
	    padding: 1px 16px;
	    box-shadow: 0 2px 5px #eaeaea;
	}
	.tip {
	    color: #ff1400;
	    padding-top: 3px;
	    text-align: left;
	    padding-left: 3px;
		font-size:12px ;
	}
	/deep/ .el-input--small .el-input__inner{
		padding: 0px 10px;
	}
	.tel {
	    display: flex;
	    align-items: center;
	}
	/* .tel .input {
		margin-left: 15px;
	    width: 213px;
	    margin-right: 15px;
	} */
	.el-button--primary {
	    color: #FFF;
	    background-color: #106a95;
	    border-color: #106a95;
	    line-height: 18px;
	    transition: .3s;
	}
	.el-button--primary:hover {
	    background-color: rgba(16, 106,149, .8);
	    border-color: rgba(16, 106,149, .8);
	}
</style>



// WEBPACK FOOTER //
// src/views/main/main.vue